import React from "react";
const Badge = ({ name, color, wide, setAnimation }) => {
  return (
    <div
      className="Badge"
      style={{
        background: color ? "rgba(69,170,67,0.15)" : "rgba(141, 7, 146,0.15)",
        color: color ? color : "#8D0792",
        cursor: "pointer",
        width: wide ? wide : "auto",
      }}
    >
      <div
        className="Badge__circle"
        style={{
          animation: setAnimation && "grow 0.75s infinite",
          background: color ? color : "#8D0792",
        }}
      ></div>
      <p style={{ margin: 0 }}>{name ? name : "Compare"}</p>
    </div>
  );
};

export default Badge;
